import { Input } from "@fronterahealth/frontera-ui-components/ui/input";

import { ReportFieldDisabledValue } from "@components/ReportField/ReportFieldDisabledValue";
import { ReportFieldInputBaseProps } from "@components/ReportField/types";

export const TreatmentPlanDatetime: React.FC<ReportFieldInputBaseProps> = ({
  id,
  value,
  onChange,
  variant,
  disabled,
  onFocus,
  onBlur,
}) => {
  if (disabled) return <ReportFieldDisabledValue value={value} />;
  return (
    <Input
      id={id}
      variant={variant}
      type="datetime-local"
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      onFocus={onFocus}
      onBlur={onBlur}
    />
  );
};
